import { supabase } from '../config/supabaseClient';

export async function getPopups() {
  const { data, error } = await supabase
    .from('site_popup')
    .select('*')
    .order('updated_at', { ascending: false });

  if (error) throw error;
  return data;
}

export async function getActivePopups() {
  const { data, error } = await supabase
    .from('site_popup')
    .select('*')
    .eq('is_active', true)
    .order('updated_at', { ascending: true });

  if (error) throw error;
  return data;
}

export async function createPopup(popup) {
  const { data, error } = await supabase
    .from('site_popup')
    .insert([{ ...popup, updated_at: new Date().toISOString() }])
    .select()
    .single();

  if (error) throw error;
  return data;
}

export async function updatePopup(id, popup) {
  const { data, error } = await supabase
    .from('site_popup')
    .update({ ...popup, updated_at: new Date().toISOString() })
    .eq('id', id)
    .select()
    .single();

  if (error) throw error;
  return data;
}

export async function deletePopup(id) {
  const { error } = await supabase
    .from('site_popup')
    .delete()
    .eq('id', id);

  if (error) throw error;
}
